import React, { useEffect, useState } from "react";
import { UiComponents, FilterIcon, UnoStoreHooks } from "@simulanisindia/ui";
import SelectionLine from "../../../components/SelectionLine";
import { useModalContext } from "../../../modal/context/ModalProvider";
import { modalName, toggleArraySingleValue } from "../../../utils/general";
import { ROLE_ASSIGNMENTS } from "../../../constant/constants";
import apiClient from "../../../apiClient";
import { DELETE_ROLE_USERS, UPDATE_ROLE_USERS } from "../../../apiClient/apiEndpoints";
import useSuccessfulModal from "../../../pages/useSuccessfulModal";
import { useSelector } from "react-redux";
import UserRoleSkelton from "../../Skeleton/UserRoleSkelton";
import NoDataFound from "../../NoDataFound";

const { useUnoSelector } = UnoStoreHooks;
const { SimCheckBox } = UiComponents;

const tableHeaders = [{ title: <> </> }, { title: "Name" }, { title: "Email" }, { title: "Group Name" }];
const { SearchBar, Table, SimFilter } = UiComponents;

const RoleAssigments = ({
  onlyView = false,
  fetRoleUserLoading,
  getRoleUsers,
  roleUserList = [],
  name,
  UUID,
  selectedUsers,
}) => {
  const configData = useUnoSelector((state) => state.config);
  const groupData = useSelector((state) => state.groupSlice);
  const handleOpenSuccessfulModal = useSuccessfulModal(1500, "User updated Successfully.");
  const [tableRows, setTableRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [filterOptions, setFilterOptions] = useState([]);
  const [querySearch, setQuerySearch] = useState("");
  const [selectedFilterCheckbox, setSelectedFilterCheckbox] = useState([]);
  const [deleteCheckbox, setDeleteCheckbox] = useState([]);
  const { openModal, closeModal, handleLoading } = useModalContext();

  const handleClearSelection = () => {
    setDeleteCheckbox([]);
  };

  const handleMultipleStatusChange = () => {};

  const handleToggleSelectUser = (id) => {
    setDeleteCheckbox((pre) => toggleArraySingleValue(pre, id));
  };

  useEffect(() => {
    let groupFilter = (groupData?.allChildren || []).map((group) => {
      return {
        name: group.name,
        key: group.uuid,
        value: group.uuid,
      };
    });
    setFilterOptions([
      {
        name: "Group types",
        tags: groupFilter,
      },
    ]);
  }, [groupData]);

  useEffect(() => {
    let filteredUsers = roleUserList;
    if (querySearch) {
      const lowerCaseQuery = querySearch.toLowerCase();
      filteredUsers = roleUserList.filter((user) => user.name.toLowerCase().includes(lowerCaseQuery));
    }
    if (selectedFilterCheckbox.length > 0) {
      const groupIds = new Set(selectedFilterCheckbox.map((e) => e.value));
      filteredUsers = filteredUsers.filter((user) => groupIds.has(user.group.uuid));
    }

    let tableList = filteredUsers.map((user) => {
      return {
        cellData: [
          {
            value: (
              <SimCheckBox
                disabled={onlyView ? Boolean(true) : Boolean(false)}
                checked={deleteCheckbox.includes(user.uuid) ? true : false}
                onChange={() => handleToggleSelectUser(user.uuid)}
              />
            ),
          },
          { value: user.name },
          { value: user.email || user.uid },
          { value: user.group.name },
        ],
      };
    });
    setTableRows(tableList);
  }, [roleUserList, querySearch, deleteCheckbox, selectedFilterCheckbox]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setQuerySearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  const handleUpdateRoleUsers = async (usersId, toDelete) => {
    if (loading) return;
    try {
      setLoading(true);
      let bodyData = {
        users: usersId.filter((id) => !selectedUsers.includes(id)),
        toDeleteUsers: toDelete.filter((id) => selectedUsers.includes(id)),
      };
      await apiClient.post(`${configData.config.UNO_URL}${UPDATE_ROLE_USERS}/${UUID}`, bodyData);
      handleOpenSuccessfulModal();
      if (getRoleUsers) getRoleUsers();
    } catch (error) {
      console.log(error);
      closeModal();
    } finally {
      handleLoading(false);
      setLoading(false);
    }
  };

  const handleOpenAssignRole = () => {
    openModal({
      modalName: modalName.ASSIGN_ROLE,
      uuid: UUID,
      roleName: name,
      selectedUsers,
      handleRefreshTab: handleUpdateRoleUsers,
    });
  };

  const body = document.body;
  const openFilter = () => {
    setShowFilter(!showfilter);
    if (!showfilter) {
      body.classList.add("filter-active");
    } else {
      body.classList.remove("filter-active");
    }
  };

  const handleSelectAllItems = (type) => {
    if (onlyView) return;
    if (type === "all") {
      setDeleteCheckbox(roleUserList.map((e) => e.uuid));
    } else if (type === "none") {
      setDeleteCheckbox([]);
    }
  };

  const handleDeleteRoleUsers = async () => {
    if (loading) return;
    try {
      setLoading(true);
      let bodyData = {
        users: deleteCheckbox,
      };
      await apiClient.post(`${configData.config.UNO_URL}${DELETE_ROLE_USERS}/${UUID}`, bodyData);
      handleOpenSuccessfulModal();
      setDeleteCheckbox([]);
      if (getRoleUsers) getRoleUsers();
    } catch (error) {
      console.log(error);
      closeModal();
    } finally {
      handleLoading(false);
      setLoading(false);
    }
  };

  const handleOpenConfirmModal = () => {
    openModal({
      modalName: modalName.CONFIRM_BOX,
      title: "Delete users",
      message: "Are you sure to delete selected users",
      confirmBtnName: "Confirm",
      handleConfirmClick: handleDeleteRoleUsers,
    });
  };

  return (
    <>
      <div className="role-assignments-card">
        <div className="role-header">
          <div className="role-header-detail">
            <h5>Role assignments</h5>
            <p>Here you can add users for assign "{name}" role</p>
          </div>

          {!onlyView && (
            <div className="roleassigmentsdata">
              <div className="searchwithborder ">
                <SearchBar placeholder="Search User..." value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
              <div className="filterbtn" onClick={openFilter}>
                <div className="btninadjust">
                  <FilterIcon />
                  {selectedFilterCheckbox.length > 0 && <span className="filter-active-span"></span>}
                </div>
              </div>
              <button onClick={handleOpenAssignRole} className="create">
                Add User
              </button>
            </div>
          )}
        </div>

        {!onlyView && (
          <SelectionLine
            buttonShow={true}
            deleteButton={!onlyView && deleteCheckbox.length > 0 ? true : false}
            showDropdown={false}
            type={ROLE_ASSIGNMENTS}
            showAssignIcon={false}
            showMoveIcon={false}
            showStatusChangeIcon={false}
            // getUsersList={getUsersList}
            handleClickMultipleSelect={(e) => handleSelectAllItems(e)}
            selectedItems={deleteCheckbox}
            handleClearSelection={handleClearSelection}
            multipleProfileStatusChange={handleMultipleStatusChange}
            totalItemsCount={roleUserList.map((e) => e.uuid).length}
            handleDeleteItemClicked={handleOpenConfirmModal}
            text={
              <>
                {deleteCheckbox.length} Users are selected.
                <span className="cursor-pointer text-danger" onClick={handleClearSelection}>
                  Clear Selection
                </span>
              </>
            }
          />
        )}

        <div className="role-table">
          {fetRoleUserLoading ? (
            <UserRoleSkelton header={tableHeaders} />
          ) : tableRows.length > 0 ? (
            <Table tableHeaders={tableHeaders} tableRows={tableRows} tableClass="table-striped table-bordered" />
          ) : (
            <NoDataFound headText="No Data Found." />
          )}
        </div>
      </div>

      <SimFilter
        showfilter={showfilter}
        selectedCheckboxes={selectedFilterCheckbox}
        setSelectedCheckboxes={setSelectedFilterCheckbox}
        filterOptions={filterOptions}
        onToggleFilter={openFilter}
      />
    </>
  );
};

export default RoleAssigments;
